import React from 'react';
import {createRoot} from 'react-dom/client';
import 'src/Services/i18n';
import App from './App';
import UserProvider from "./Contexts/UserContext";
import {ThemeProvider} from "styled-components";
import {Theme} from "./Assets/Styles/Theme";
import {BrowserRouter} from "react-router-dom";
import {PrimeReactProvider} from "primereact/api";

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <BrowserRouter>
        <UserProvider>
            <ThemeProvider theme={Theme}>
                <PrimeReactProvider>
                    <App/>
                </PrimeReactProvider>
            </ThemeProvider>
        </UserProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
